<template>
  <div class="form-inline">
    <input 
      id="searchInput" 
      type="text"
      placeholder="Search" 
      style="min-width: 50%;"
      class="searchForm form-control form-control-sm" 
      v-model="searchForm" 
      @keyup.enter="onChangeForm"
      :maxlength="$root.const.profileLocationMaxLen + $root.const.publicPageTitleMaxLen"
      >
    <div class="btn-wrap">
      <button type="button" @click="onChangeForm" class="btn btn-outline-primary btn-sm" style="margin:4px;">検索</button>
    </div>
  </div>
</template>

<script lang="ts">
import RootVue from '@/RootVue.vue';
import { Vue, Options } from 'vue-class-component';

@Options({ 
  components: {  },
  props:{
    initialValue:{
      type:String
    }
  }
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;
  readonly initialValue!:string;
  searchForm = "";

  onChangeForm() {
    this.$router.push({ path: window.location.pathname, query: { q: this.searchForm } });
  }
  created(){
    //モバイルでinputにフォーカスするとキーボードが画面を占拠するため
    if(!this.$root.isMobile){
      this.$root.focus("searchInput")
    }
    this.searchForm = this.initialValue
  }
}
</script>
<style lang="scss" scoped>
  .btn-wrap{
    display: inline-block;
    text-align: center;
  }
  
@media (max-width: 576px) {
  .btn-wrap {
    display: block;
    width: 100%;
  }
}

@media (min-width: 576px){
    .form-inline .form-control {
        display: inline-block;
        width: auto;
        vertical-align: middle;
    }
}
.form-inline {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
}
</style>


